import React from 'react';
import ArticleBanner from '../ArticleBanner/ArticleBanner';
import DisqusComments from '../Disqus/DisqusComments';

class GreenhousePart2 extends React.Component {
  componentDidMount() {
    // console.log("props: ", this.props);
  }
  render () {
    const { articleIsPending, articleData, articleError } = this.props;
    // console.log("props: ", this.props);
    const images = require.context('../../images', true);
    const files = require.context('../../files', true);
    let greenhouse3DModel1 = images('./greenhouse3DModel1.png');
    let greenhouseCAD = files('./Greenhouse.FCStd');
    let greenhouseCoverPic = images('./greenhouse-part-2-header.jpg');
    let drakeComputer = images('./drake-computer.gif');
    let howtoowl = images('./how2owl.png');
    let amishroof = images('./amishroof.gif');
    let craneroof = images('./craneroof.gif');
    let wackyshack = images('./wackyshack.gif');
    let greenhouseStep1 = images('./greenhouse2Step1.png');
    let greenhouseStep21 = images('./greenhouse2Step2-1.png');
    let greenhouseStep22 = images('./greenhouse2Step2-2.png');
    let greenhouseStep31 = images('./greenhouse2Step3-1.png');
    let greenhouseStep32 = images('./greenhouse2Step3-2.jpg');
    let greenhouseStep33 = images('./greenhouse2Step3-3.jpg');
    let greenhouseStep34 = images('./greenhouse2Step3-4.png');
    let greenhouseStep41 = images('./greenhouse2Step4-1.png');
    let greenhouseStep42 = images('./greenhouse2Step4-2.jpg');
    let greenhouseStep43 = images('./greenhouse2Step4-3.jpg');
    let greenhouseStep51 = images('./greenhouse2Step5-1.jpg');
    let greenhouseStep52 = images('./greenhouse2Step5-2.jpg');
    let greenhouseStep53 = images('./greenhouse2Step5-3.jpg');
    let greenhouseStep61 = images('./greenhouse2Step6-1.jpg');
    let greenhouseStep62 = images('./greenhouse2Step6-2.jpg');
    let greenhouseStep63 = images('./greenhouse2Step6-3.jpg');
    let greenhouseStep71 = images('./greenhouse2Step7-1.jpg');
    let greenhouseStep72 = images('./greenhouse2Step7-2.jpg');
    let greenhouseStep81 = images('./greenhouse2Step8-1.jpg');
    let greenhouseStep82 = images('./greenhouse2Step8-2.png');
    let greenhouseStep83 = images('./greenhouse2Step8-3.jpg');
    let greenhouseStep84 = images('./greenhouse2Step8-4.jpg');
    let greenhouseStep85 = images('./greenhouse2Step8-5.jpg');
    let greenhouseStep91 = images('./greenhouse2Step9-1.jpg');
    let greenhouseStep92 = images('./greenhouse2Step9-2.png');
    let greenhouseStep93 = images('./greenhouse2Step9-3.jpg');
    let greenhouseStep94 = images('./greenhouse2Step9-4.png');
    let greenhouseStep95 = images('./greenhouse2Step9-5.jpg');
    let greenhouseStep96 = images('./greenhouse2Step9-6.gif');
    let greenhouseStep101 = images('./greenhouse2Step10-1.png');
    let greenhouseStep102 = images('./greenhouse2Step10-2.gif');
    let greenhouseStep103 = images('./greenhouse2Step10-3.jpg');
    let greenhouseStep104 = images('./greenhouse2Step10-4.png');
    let greenhouseStep111 = images('./greenhouse2Step11-1.jpg');
    let greenhouseStep112 = images('./greenhouse2Step11-2.png');
    let greenhouseStep121 = images('./greenhouse2Step12-1.jpg');
    let greenhouseStep122 = images('./greenhouse2Step12-2.jpg');
    let greenhouseStep123 = images('./greenhouse2Step12-3.jpg');
    let greenhouseStep124 = images('./greenhouse2Step12-4.jpg');
    let greenhouseStep125 = images('./greenhouse2Step12-5.jpg');
    let greenhouseStep126 = images('./greenhouse2Step12-6.png');
    let greenhouseStep127 = images('./greenhouse2Step12-7.png');
    let greenhouseStep128 = images('./greenhouse2Step12-8.jpg');
    let greenhouseStep129 = images('./greenhouse2Step12-9.gif');
    return (
      <div>
        <ArticleBanner articleIsPending={articleIsPending}
        articleData={articleData} articleError={articleError} />

        <div className="pt1 pa3 ph5-ns">
          <p>After a long summer the greenhouse is finally done! In retrospect
            I wish I had taken more pictures or even videos, so it wouldn't seem
            like I'm 'drawing the rest of the owl'.
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={howtoowl} alt="How to draw an owl" />
            <p><i>If I ever made a FreeCAD tutorial, it would look like this</i></p>
          </div>
          <p>With very little prior experience in carpentry, I compensated by
            drawing on my other nerd skills, 3D modelling and following instructions
            really carefully!
          </p>
          <p>This article provides some commentary and pictures of my experience
            trying to make my own 8 foot by 12 foot greenhouse design a reality!
            It's not quite detailed enough to be a guide, but I hope you find it
            a little informative or interesting!
          </p>
          
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouse3DModel1} alt="Greenhouse 3D Model - Front" />
            <p><i>It's virtually done!</i></p>
          </div>
          <p>The plan is missing a few minor details, like screws/hardware,
            gutters/downspouts, most of the door, drip edges, and cross-braces, BUT
            overall it covers the structure pretty well. I created it myself after
            referencing a similar design I found online. feel free to take a look
            or reference it, but remember, I'm a software engineer so all I recall
            related to structures is <i>'something something triangles'</i>. <b>I can't make
            any promises about the strength/quality of this! Also, check the permit
            requirements where you live!</b>
          </p>
          <a className="link as-hover-green" href={greenhouseCAD} download="Greenhouse.FCstd">Here's a link to the FreeCAD model anyway if you want!</a>
          <p></p>
          <h4>1. Wood??</h4>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi5"
                    src={greenhouseStep1} alt="Big pile of cedar" />
            <p><i>If I remember my Age of Empires, I just need to wail on this with a hammer for a few minutes...</i></p>
          </div>
          <p>Following the advice of some other friends with greenhouses, I decided
            to make the whole thing out of cedar, and not apply any stain/paint.
            Structurally this should be fine, and the exterior will probably just
            take on a cool silvery colour over the years.
            In retrospect, I could have made the bottom of my walls out of some
            kind of pressure treated lumber, since they're completely out of sight
            in the final design, but no biggie either way, I think.
          </p>
          <h4>2. Make Some Walls</h4>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep21} alt="Just making a wall in here" />
            <p><i>This wall needs to learn to stand up for itself </i><span role="img" aria-label="cowboy emoji">🤠</span></p>
          </div>
          <p>I started out building the walls on the biggest flattest surface I
            could find, my garage!</p>

          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep22} alt="Dry fitted all the walls together" />
            <p><i>Oh no! I built it inside! Sounds like this green-house is a gray-house </i><span role="img" aria-label="dizzy emoji">😵</span></p>
          </div>
          <p>After all the walls were made I dry-fit em together by tying the
            corners together (in the red circles) to make sure
            everying was nice and squared up! (Plus it was raining outside) If you're
            wondering what those weird angled pieces are at the base of the walls,
            they're going to go between studs to make a stub wall! I was just sort
            of resting them between the studs when I took the picture.</p>
          
          <h4>3. Make Some Walls... Outside</h4>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep31} alt="Check that level" />
            <p><i>I was using the 4 long pieces for sure, I don't know what else was going on here</i></p>
          </div>
          <p>Before bringing the walls outside, I did a quick check that the platform was still level!
            Thank god it was, because I don't really know what I could have conveniently done to fix it.
            Point A was just a little higher than point B, but it was only a tiny difference.
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep32} alt="Putting up the walls outside!" />
            <p><i></i></p>
          </div>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep33} alt="Anchoring with TapCons" />
            <p><i>If you're a carpenter and your eyebrows didn't just furrow, you made my day.</i></p>
          </div>
          <p>After convincing myself that the surface was flat enough, we put up
            the walls, squared em up, and attached them to the concrete block base
            with those TapCon things. I actually struggled a lot with choosing a
            way to anchor the structure, I did lots of googling and phoned some
            friends, and settled on this as 'good enough'.
            As of writing, the greenhouse has not yet fallen over!</p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep34} alt="Attaching the stub wall pieces!" />
            <p><i>I'm calling this a stub-wall? I'm not sure if that's the right term tho.</i></p>
          </div>
          <p>Next up, I finished putting up that stub-wall I mentioned earlier!
            This will be used to support a sort of ornamental trim going around
            the base of the greenhouse. Its purpose is to look cute, create a
            space to install a layer of insulation later if I want, and save me
            some money on polycarbonate :)</p>
          <h4>4. Build Roof Truss/Rafter Things</h4>
          <p>A while later we started working on the roof... "Trusses"? I'm
            genuinely not really sure if these are technically trusses, or
            rafters that are shaped weirdly. Despite having built this thing
            I'm still underwater when it comes to terminology sometimes!</p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep41} alt="Roof Truss? or Roof Rafter?" />
            <p><i>I believe the correct term is 'Triangle Roof Thingy'.</i></p>
          </div>
          <p>We just slapped these things together with deck screws that we
            toe-screwed in at an angle. To me this seems like a good-enough
            solution. You could probably construct these things in a way that's
            stronger and hides the screws, but I didn't feel like going that
            above and beyond at the time. We kept these consistent by making a
            little jig out of a piece of scrap plywood and other scrap wood.
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep42} alt="Triangle Roof Thingy" />
            <p><i>If you're a carpenter pls put your eyebrows back down</i></p>
          </div>
          <p>We needed one Triangle Roof Thingy above each of the edges and above each
            of the 5 studs in the wall, so we made a pile of 7!
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep43} alt="Seven Triangle Roof Thingies" />
            <p><i>Every night I go to sleep smiling, thinking about how I didn't mess these up</i></p>
          </div>
          <h4>5. Make a Roof (On The Ground)</h4>
          <p>At this point I was really scratching my head over how I was going
            to safely get this roof built, when my friends dropped a
            construction-wisdom-truth-bomb on me:</p>
          <p><b>Build the roof on the ground!</b></p>
          <p>Basically instead of trying to channel my inner Amish Energy and do this:</p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={amishroof} alt="Amish roof building" />
            <p><i>I don't know if I have any inner Amish Energy tbh</i></p>
          </div>
          <p>I can do this!</p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={craneroof} alt="Lifting a roof with a crane" />
            <p><i>But like, 4 dudes instead of a crane, and a greenhouse instead of a garage. Same idea!</i></p>
          </div>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={drakeComputer} alt="Drake Computer meme" />
            <p><i>Yeah honestly I have never even seen a large shed or garage being constructed</i></p>
          </div>
          <p>So, I set to putting all the roof bits together on the back deck,
          which was adequately flat for the job!</p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep51} alt="Putting roof together on the ground" />
            <p><i></i></p>
          </div>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep52} alt="Putting roof together on the ground 2" />
            <p><i>Yeah I definitely would have died trying to do this on a ladder</i></p>
          </div>
          <p>Unfortunately I'm missing a picture of the roof with the long edges
            connecting all the Thingies, before myself and 3 buddies yeeted it on
            the roof! It wasn't totally flat at first but we were able to screw
            it down to the top of the wall pretty well!</p>
          <p>For any of you wondering why I went with
            a <a className="link as-hover-green" href="https://build.com.au/clerestory-roof">clerestory roof</a>, it
            was 90% because it looks cool, 10% because I think it might encourage
            good airflow/ventilation. I'm not totally sure to what degree it would
            help with ventilation over a typical design with a hatch-window on the
            roof though, so I'm prepared to 100% justify the design choice as "looking cool".</p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep53} alt="Greenhouse with the roof on!" />
            <p><i>Can't go back now! Because I don't know how</i></p>
          </div>
          <h4>6. Windows and Roof Panels</h4>
          <p>Next up I realized that we probably put the roof on the walls
            prematurely, since I still had to attach a bunch of other pieces to
            serve as the... back/frames of the windows? And the windows. And all
            the polycarbonate panels. It would have been a million times easier
            on the ground but I guess I was worried about twisting the whole roof
            and damaging those parts by picking the whole thing up. It probably would have
            worked out either way!</p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep61} alt="Greenhouse Window backs" />
            <p><i>Ripping the 2x4's at an angle was one of the trickier cuts!</i></p>
          </div> 
          <p>The windows themselves were made to hang down off the top beam of the
            roof, and have an angled bottom so they could rest against the
            polycarbonate on the roof!</p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep62} alt="A greenhouse window" />
            <p><i>Made these by hella chopping up some 2x4s and slapping a polycarbonate panel on there!</i></p>
          </div> 
          <p>Speaking of polycarbonate, I used 6mm twin-wall clear polycarbonate
            from <a className="link as-hover-green" href="https://www.ecofort.ca/">this supplier</a> in Calgary!
            We used mono-H channels to connect
            adjacent panels, which is considered the "cheap" way to do it, but
            have you SEEN the price of the two-piece or aluminum channels?
            I already built the whole thing out of cedar in 2021, give me a break!
            You'll also notice that we put a little aluminum ridge cap along the top beam and
            some drip edges on the front and back of the roof. Maybe overkill, 
            but better water management helps me sleep at night.</p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep63} alt="Greenhouse with roof and windows on" />
            <p><i>Shout outs to my guy Connor! Yeeee haw</i></p>
          </div> 
          <p>I wish I had more pictures of us putting the roof panels on, but it
            was too much of a pain to do any photography at the same time. Lots
            of leaning at the top of a ladder to get all the little screws in.
          </p>
          <h4>7. Cross Bracing</h4>
          <p>Something I did notice after doing all that work on the roof, is
            that the whole structure is pretty much... wacky shack along the front to back.</p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={wackyshack} alt="WaCkY sHaCk!" />
            <p><i>It wasn't quite this bad, but it was close!</i></p>
          </div> 
          <p>Normally when building little sheds or houses of this size, plywood
            is attached to the walls, which does an amazing job of cross-bracing
            the structure in that plane. However, with greenhouses you may have
            to put some thought into bracing the structure another way!</p>
          <p>As you can see in some earlier pictures I had already added some
            braces on the front and back walls of the greenhouse, but wasn't
            sure if it would be as effective in the other direction.
            Before going to the trouble of carefully cutting out some more cute
            cross-braces, we checked that it would actually be effective by
            doing this:</p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep71} alt="Experimental cross braces" />
            <p><i>Yup, ready for the Parade of Homes</i></p>
          </div> 
          <p>With that quick test out of the way, I actually cut up and installed
            the cute version:
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep72} alt="Gucci cross braces" />
            <p><i>The shack is un-wacked</i><span role="img" aria-label="clap emoji"></span>👏</p>
          </div> 
          <p>Cutting out these cross braces was actually kind of an annoying trial
            and error process. They weren't part of my original CAD plan so I didn't
            really have any specific dimensions I knew would work. I pretty much
            just did my best to make them fit in the space at a somewhat consistent
            angle. There was a lot of cutting, shaving, seeing if they fit, repeat.
            In the end it worked out well and looks pretty cute, but secretly it
            was probably the hackiest part of the project.
          </p>
          <h4>8. Stub Wall!</h4>
          <p>The first layer of the so-called stub wall is some 1/4" thick plywood
            which we coated with stain to help it not turn to rotten goop as fast.
            We also attached it to the walls such that it's not touching the ground,
            which will also help keep it dry! I wasn't initally going to have this layer,
            but a friend recommended doing this so that the whole wall would be
            more air-tight (compared to my initial plan of just slapping a ton of
            cedar planks on the wall!).
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep81} alt="Putting on the plywood for the stub wall!" />
            <p><i>It doesn't go right to the edges either, but that'll be hidden anyway!</i></p>
          </div> 
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep82} alt="Plywood all around the stub wall" />
            <p><i>Plywood all the way around! It's looking kind of cute already :D</i></p>
          </div> 
          <p>Next up was the bulk of the stub-wall, hella pieces of 1x6 cedar fence
            boards all around the outside! To help keep this from turning into a
            gap-toothed mess down the road, I had let all these pieces sun-dry for
            days before actually nailing them to the wall.
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep83} alt="Cedar planks all around the stub wall!" />
            <p><i>I'm a big fan of all the different tones and textures here!</i></p>
          </div> 
          <p>Finally, I attached pieces of 1x4 cedar around all the edges to
            make a funky trim! (In the original CAD plans, the long walls have
            a little vertical piece of trim in front of every stud, but I think
            just a single one in the middle looked better.)
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep84} alt="Finished stub wall" />
            <p><i>All this work and I still don't know if "stub wall" is the right term</i></p>
          </div> 
          <p>One design decision that I am literally still on the fence about was
            joining the corner pieces together with 45 degree cuts. It looks most
            handsome indeed when they actually fit together (like in the picture below)
            but over time they're starting to separate a bit, which I kind of expected.
            I'm still not sure if the fancy 45 degree joints was the right call! But
            I like it for now.
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep85} alt="Angled cuts for the stub wall trim" />
            <p><i>Hopefully it still lines up half this well after 5 years outside!</i></p>
          </div> 
          <h4>9. Polycarbonate on the Walls</h4>
          <p>Getting the panels on the walls was much easier compared to the struggles
            of getting them secured to the roof. I started out by putting a little
            fascia-trim thingy along the top edge of the wall! This covers the gaps
            between the roof rafters, creates a nice space for the panels to fit into
            below, and will provide a space to attach gutters down the road.
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep91} alt="Attaching fascia to the walls" />
            <p><i>I love this clamp so much, just saying</i></p>
          </div> 
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep92} alt="Front wall trim" />
            <p><i>We also did this trim on the front and back walls! (In red)</i></p>
          </div> 
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep93} alt="Front wall trim peak" />
            <p><i>Close Up! This trim joins at the top and fits under the drip edges.</i></p>
          </div> 
          <p>The pic below does a pretty good job capturing the layering - I attached a big
            drip edge on the top of the stub wall, then attached the polycarbonate panels
            in front! This way most of the water hitting the walls will flow away from the
            stub wall. This was important to me because all the layers of wood in the stub
            wall are a pretty tight sandwich, and a lot of water getting between the layers
            could be problematic over time, even if all the wood involved is able to resist rot.
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep94} alt="Attaching polycarbonate on the walls!" />
            <p><i>Not nearly the same look as glass, but the shimmering is kinda cool!</i></p>
          </div> 
          <p>The front and back walls had their own little challenges. The back side of the
            greenhouse was weirdly windy when I was putting the panel up, so I had to kind of 
            hold it in place with some big wood bois and work quickly to screw it down:
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep95} alt="Attaching polycarbonate to the back wall" />
            <p><i>Using tape during install because the mono-H channels don't do a lot to hold panels together!</i></p>
          </div> 
          <p>The challenge with the front wall was getting this all chopped up to just the right size.
            It started out looking the same as the back wall, but then I marked out the space for the door
            and cut it out with a jigsaw. I spent a while getting this right,
            since it's the face of the whole project and I was out of spare panels!
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep96} alt="Front panels on the greenhouse" />
            <p><i>6mm Polycarbonate panels are way more floppy than I expected I must say</i></p>
          </div> 
          <h4>10. Auto Window Openers!</h4>
          <p>Homestretch now! Other than the door, one component I was very excited
            about since the inception of the project were
            these <a className="link as-hover-green" href="https://www.amazon.ca/gp/product/B07P7VZV2C/ref=ppx_yo_dt_b_asin_title_o00_s00?ie=UTF8">
            automatic window openers</a>!
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep101} alt="Window Openers" />
            <p><i>One of these, slightly off center, for each of the 3 windows!</i></p>
          </div> 
          <p>
            These little guys are essential for
            allowing excess heat to escape and keep
            the greenhouse from turning into an oven when I'm too lazy to open
            the door in the morning! <a className="link as-hover-green" href="https://www.harvst.co.uk/how-do-automatic-greenhouse-window-openers-work/">
            They work by</a> using a cylinder full of a mineral wax which melts and
            expands between 18~25 degrees to push the window open! The strong
            spring also holds the window shut tightly when it's cold.
            Here's a lil GIF of me pushing the window open manually with the
            mechanism attached, minus the cylinder.
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep102} alt="Window Openers in Action" />
            <p><i>This GIF is kind of giving me motion sickness tbh, sorry about that</i></p>
          </div> 
          <p>I kind of had to install them in an unusual way due to the weird shape
            and position of the windows, but they fit okay with the uh, window-bit oriented
            horizontally, and the window-frame-bit attached vertically. It also
            applied quite a bit of torsion to the window frame and I lowkey did
            not attach those pieces with the might of Zeus, so I added an L-bracket
            to make the whole window frame a little beefier where the window opener was.
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep103} alt="Window Frame With L Bracket" />
            <p><i>You'd have to twist the whole frame apart for this to break now! (Please do not twist the whole frame apart)</i></p>
          </div> 
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep104} alt="Greenhouse with Window Open" />
            <p><i>Snapped this picture after installing the first window opener! I did the other two afterwards.</i></p>
          </div> 
          <h4>11. Beef up the Center Truss Triangle Thing</h4>
          <p>At this time, another friend suggested totally beefing up the center
            truss, primarily to avoid the whole thing collapsing under a big snow load.
            I have absolutely have no idea how much snow this thing could handle
            before or after this improvement, but I do feel confident that it was
            a worthwhile and cool improvement!
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep111} alt="Truss center hanging from T brackets" />
            <p><i>I installed this center thingy first with some big ol T's</i></p>
          </div> 
          <p>I installed the center of the addition first, using some big beefy T brackets.
            Then I held up and installed the sides (shown in purple below) one at a time,
            which was REALLY HARD! Ideally one person should hold the member in place while
            a friend screws it down, instead of doing those jobs with one hand each.
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep112} alt="Greenhouse Center Truss Thingy" />
            <p><i>If you've got criticisms of my tomato pruning, I just want to say you're right, and I'm sorry</i></p>
          </div> 
          <h4>12. Make a Door?</h4>
          <p>Since I first started coming up with designs in February I knew
            I wanted a super cute Dutch door, which could open completely, halfway,
            or halfway with just a mesh (to let bugs in but keep birds out, I suppose).
            As a disclaimer, I have literally never even installed a door, or gate,
            much less made a Dutch door from scratch! The final design isn't really
            included in the CAD file above, I just kind of hashed it out with knowledge
            of <a className="link as-hover-green" href="https://www.slidegate.net/what-is-the-right-way-to-brace-a-gate">the
            right way to brace a gate</a> and an idea of what I wanted. By this point
            I was surprised to find that I was confident enough in my carpentry skills
            to make something without relying on a perfect CAD model, which was a
            pretty cool feeling! :D
          </p>
          <p>The bottom half of the door was pretty simple. I ripped a 2x6 in half
            to make some 2x3s, which I used to make the outer frame. I put a 2x4
            diagonally through the center for my beefy cross-brace.
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep121} alt="Lower door frame" />
            <p><i>This picture is kind of terrible but it's the only one I have :(</i></p>
          </div> 
          <p>It happened to work out that the lower half of the door needed to be
            3 feet tall and 33 inches wide. So, it was super convenient to make
            the most doorlike part of the door out of three 6' long 1x6 cedar fence
            boards cut in half! I also left these guys out to dry for a few
            days to reduce the chance of shrinkage that would land me with 5 big
            gaps in the door.
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep122} alt="Lower door without trim" />
            <p><i>*Slaps roof of door* "This door can fit so much door in it"</i></p>
          </div> 
          <p>The final part of the bottom half of the door was a little border
            of 1x4's joined at 45 degrees. 
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep123} alt="Lower door in position" />
            <p><i>I tried to leave like 1/2-1/4" on either side. If it didn't fit I'd just give up and hang a beaded curtain.</i></p>
          </div> 
          <p>At this point I have to apologize if you were hoping for more information
            on the top half of the door, because I had like 1 HP left and only took
            three halfway decent pictures of the door under construction.
            The frame was again 2x3s, but with a really weird trim-cross-brace situation going on.
            My goal was essentially to have a single 3/4" layer for a trim
            and cross brace, so that the top half of the door would be the same thickness
            as the lower door, and have a cross brace while allowing a space
            in the middle for an <i>inner screen door thingy</i>. I would attach
            mesh to the back of the frame here!
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep124} alt="Upper door frame" />
            <p><i>The cross brace is a 1x4, and I think the trim is like... 1x2s.</i></p>
          </div> 
          <p>Speaking of the inner screen door thingy, I made one by kind of sandwiching
            a thin sheet of acrylic between some other narrowly cut pieces of cedar joined
            at 45 degrees for some reason?? I mean I like the 45 degree aesthetic here, but
            I don't think it helped with the structural integrity at all. I totally thought
            that sandwiching the sheet with screws would help hold everything together,
            but I needed to run screws vertically at the corners to properly hold the
            frame together. 
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep125} alt="Assembling the screen door" />
            <p><i>Again with 45 degree corners... I think I was just way too hyped to have a miter saw.</i></p>
          </div> 
          <p>The next pic shows the top half of the door all assembled, sans hinges.
            Hopefully you can imagine the inner screen door pivoting on inner hinges
            (in green) and the entire door attached with another set of hinges
            (in purple)
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep126} alt="Top half of the door" />
            <p><i>I remember being quite hyped indeed that I didn't goof this up</i></p>
          </div> 
          <p>I don't have anything insightful to share regarding how I installed
            the doors, but there was a mishap with a Phillips screw missing a quarter
            of it's phillips-ness:
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep127} alt="Bad phillips screw" />
            <p><i>A most unfortunate illips screw</i></p>
          </div> 
          <p>Lucky for me, I had a deck screw handy that could play the part
            just fine with a bit of makeup...
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep128} alt="Unscrewing myself with this screw" />
            <p><i>If the sharpie wears off, I'll still try nail polish before buying a new screw</i></p>
          </div> 
          <p>With that crisis averted, at least temporarily, I slapped the doors on
            and tried out the different states of Dutch-ness! 
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseStep129} alt="Top half of the door opening" />
            <p><i>Some critters, less critters, no critters!</i></p>
          </div> 
          <h4>Closing Thoughts</h4>
          <p>With the door on, that was pretty well it for the structure! There's more
            to talk about regarding irrigation, gutters, downspouts and rain barrels,
            but I'm saving all of that for a part three!
          </p>
          <div className="block mv2 tc">
            <img loading="lazy" className="br2 mhi6"
                    src={greenhouseCoverPic} alt="Finished greenhouse with gutters!" />
            <p><i>Step 13. Draw the rest of the greenhouse</i></p>
          </div> 
          <p>Oh! I guess I forgot to mention that I cut out a little triangle of
            acrylic to fill that triangle shaped hole on the front and back sides
            where the uh, long part of the roof overlaps the short part of the roof.
            I was originally thinking of doing something with stained glass, but I
            was at 0 HP at this point and just wanted something halfway decent to
            get the project across the finish line.
          </p>
          <p>Off the top of my head I think my top 3 pieces of advice to someone
            making their own greenhouse would be:
            <ol>
              <li>Find good local suppliers for your bulk building materials (wood/metal, polycarbonate/glass).
                This will by far be your biggest expense, and biggest opportunity for savings! Search around and get quotes!
              </li>
              <li>Make sure you're ready to put in the effort! Compared to some designs online I
                still think my design wasn't that complicated, and it still took me <i>months</i> of
                evening/weekend time. If you can find what you need at a price that works,
                greenhouse kits are still awesome!
              </li>
              <li>If possible, get feedback on your design! This project taught me
                a lot about not just asking for help, but how happy most people are
                to lend a hand. I had a lot of fun evenings hashing out design details
                with friends and family, and the project came out much better because of it!
              </li>
            </ol>
          </p>
        </div>
        <DisqusComments articleIsPending={articleIsPending}
          articleData={articleData} articleError={articleError} />
      </div>
      );
  }
}

export default GreenhousePart2;